<span class="relative flex flex-col w-full h-full">
    <div class="p-8 pb-6" mat-dialog-content>
        <ng-container>
            <div class="absolute top-0 right-0 pt-4 pr-4">
                <button (click)="close()" mat-icon-button>
                    <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
            </div>
        </ng-container>
        <ng-container>
            <div class="sm:flex xs:block w-100 border-b pb-[10px] items-center">
                <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-30pr items-center max-w-[200px]">
                    <mat-icon class="icon-size-10 ml-[10px] text-primary" [svgIcon]="'heroicons_solid:user'" matPrefix></mat-icon>
                </div>
                <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-70pr">
                    <div class="py-2 text-2xl sm:text-4xl font-bold truncate sm:ml-[20px] basic-fuse-gray-color">{{data.data.name}}</div>
                </div>
            </div>
            <div class="float-left w-full mt-2 mb-2">
                <ng-container>
                    <div class="flex flex-row flex-wrap mt-2 mb-4 gap-x-6">
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_ssn' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{formatKennitala(data.data.ssn)}}</div>
                        </div>
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_birthdate' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{data.data.birthdate | date:'dd.MM.yyyy'}}</div>
                        </div>
                        @if (data?.data?.familyNumber) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_familynumber' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{data.data.familyNumber}}</div>
                        </div>
                        } @if (data?.data?.gender) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_gender' | translate }} (nr.)</div>
                            <div class="mt-2 font-medium text-2xl leading-none">
                                {{ data.data.genderTranslationKey | translate }} (nr. {{data.data.gender}})
                            </div>
                        </div>
                        } @if (data?.data?.nationality) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_nationality' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{data.data.nationality}}</div>
                        </div>
                        }
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_deceased' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{data.data.outcome == 'LÉST' ? 'Já' : 'Nei'}}</div>
                        </div>
                        @if (data.data.outcome == 'LÉST') {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_deceased_date' | translate }}</div>
                            <div class="mt-2 font-medium text-2xl leading-none">{{formatDate(data.data.OutcomeDate)}}</div>
                        </div>
                        } @if (data?.data?.maritalStatus) {
                        <div class="flex flex-col my-3">
                            <div class="text-sm font-medium leading-none text-secondary">{{ 'label_marriage' | translate }} (nr.)</div>
                            <div class="mt-2 font-medium text-2xl leading-none">
                                {{ data.data.maritalStatusTranslationKey | translate }} (nr. {{data.data.maritalStatus}})
                            </div>
                        </div>
                        }
                    </div>
                </ng-container>
                @if (data?.data?.address) {
                <mat-divider class="my-4"></mat-divider>
                <div class="text-xl font-bold truncate basic-fuse-gray-color">{{ 'label_address' | translate }}</div>
                <div class="mt-2 font-medium text-2xl leading-none">{{ formatAddress() }}</div>
                } @if (data?.data?.spouseSSN) {
                <mat-divider class="my-4"></mat-divider>
                <div class="text-xl font-bold truncate basic-fuse-gray-color">{{ 'label_spouse' | translate }}</div>
                <div class="flex flex-row flex-wrap mb-4 gap-x-6">
                    @if (data?.data?.spouseName) {
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_name' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{data.data.spouseName}}</div>
                    </div>
                    } @if (data?.data?.spouseSSN) {
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_ssn' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{formatKennitala(data.data.spouseSSN)}}</div>
                    </div>
                    } @if (data?.data?.spouseNationality) {
                    <div class="flex flex-col my-3">
                        <div class="text-sm font-medium leading-none text-secondary">{{ 'label_nationality' | translate }}</div>
                        <div class="mt-2 font-medium text-2xl leading-none">{{data.data.spouseNationality}}</div>
                    </div>
                    }
                </div>
                }
            </div>
        </ng-container>
    </div>
</span>
